'use strict';

var processInclude = require('core/util');

$(document).ready(function () {
    processInclude(require('./search/showMoreResults'));
    processInclude(require('core/search/search'));
    processInclude(require('core/search/showMoreCategories'));
    processInclude(require('core/product/quickView'));
    processInclude(require('productcompare/product/compare'));
    processInclude(require('./components/backToTopDisplay'));
    processInclude(require('./components/seoSectionDisplay'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./experience/iframe'));
});
